<template>
  <div>
    <b-card
      :id="alias"
      :title="$t('label_reports_genderGap_indicatorStatus_title')"
      class="gauge-container"
      :style="{ height: height }"
    />
    <div
      v-if="isIndicaUser || isPNUDADMIN"
      class="IndicatorAddComment"
      @click="newComment()"
    >
      {{ $t("label_reports_genderGap_addComments")
      }}<span class="IndicatorAddCommentPlus">+</span>
    </div>
    <b-modal
      id="modalInfo"
      v-model="showModal"
      size="xl"
      class="modal-improvements modalInfo"
      style="padding: 30px"
    >
      <h5 style="margin-bottom: 20px">
        {{ $t("label_reports_genderGap_comments") }}
      </h5>
      <div>{{ $t("label_reports_genderGap_comments_description") }}</div>
      <b-form-group label-class="text-sm-left">
        <b-form-textarea id="comment" v-model="comment" type="text" required />
      </b-form-group>
      <div slot="modal-footer" class="w-100" style="text-align: right">
        <b-button variant="primary" @click="saveComment()">
          {{ $t("label_evaluation_save_button") }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { ChartGauge } from "@/utils/ChartGauge";
import { mapGetters } from "vuex";
import { createHelpers } from "vuex-map-fields";
import { axiosCall } from "@/utils/axiosCall";
const { mapFields } = createHelpers({
  getterType: "getUserAccountField",
  mutationType: "updateUserAccountField",
});
export default {
  name: "CardChartGaugeWithComment",
  props: {
    pillarId: {
      default: "",
    },
    indicatorId: {
      default: "",
    },
    alias: {
      default: "",
    },
    height: {
      type: String,
      default: "auto",
    },
  },
  data: function () {
    return {
      indicator: {},
      showModal: false,
      comment: "",
    };
  },
  watch: {
    alias: function (newVal, oldVal) {
      var svg = this.$d3.select("#" + oldVal);
      svg.selectAll(".gauge").remove();
      setTimeout(() => this.updateGauge(), 200);
    },
  },
  methods: {
    newComment() {
      this.comment = "";
      this.showModal = true;
    },
    saveComment: async function () {
      const data = {
        comment: this.comment,
        snapshotId: this.getCurrentSnapshot.snapshotId,
        // eslint-disable-next-line camelcase
        indicator_acronym: this.indicator.id,
      };
      await axiosCall({
        url: "GenderGapReportComments",
        method: "POST",
        data,
      }).then(() => {
        this.$emit("commentCreated");
        this.showModal = false;
      });
    },
    updateGauge() {
      this.indicator = this.getIndicatorData(this.pillarId, this.indicatorId);
      if (this.indicator) {
        this.createGauge(this.indicator);
      }
    },
    createGauge(indicator) {
      var tempRanges = indicator.ranges;
      var rangez = [
        tempRanges.negMin1 === "Infinity"
          ? tempRanges.negMax1 * 1.2
          : tempRanges.negMin1,
        tempRanges.negMax1,
        tempRanges.interMin1,
        tempRanges.interMax1,
        tempRanges.posMin1,
        tempRanges.posMax1,
        tempRanges.interMin2,
        tempRanges.interMax2,
        tempRanges.negMin2,
        tempRanges.negMax2 === "Infinity"
          ? tempRanges.negMin2 * 1.2
          : tempRanges.negMax2,
      ];
      var rangezDescending = rangez.slice().sort(this.$d3.descending);
      var rangezAscending = rangez.slice().sort(this.$d3.ascending);
      var min = Math.min(
        rangezAscending[0],
        indicator.markers[0],
        indicator.ideals[0]
      );
      var max = Math.max(
        rangezDescending[0],
        indicator.markers[0],
        indicator.ideals[0]
      );
      var config = {
        label: indicator.acronym,
        min: Math.round(min * 100) / 100, // indicator.negMin1,
        max: Math.round(max * 100) / 100, // indicator.negMax2,
        minorTicks: 10,
        majorTicks: 10,
        radius: 1,
      };
      config.redZones = [
        { from: config.min, to: indicator.ranges.negMax1 },
        { from: indicator.ranges.negMin1, to: config.max },
      ];
      config.yellowZones = [
        { from: indicator.ranges.interMin1, to: indicator.ranges.interMax1 },
        { from: indicator.ranges.interMin2, to: indicator.ranges.interMax2 },
      ];
      config.greenZones = [
        { from: indicator.ranges.posMin1, to: indicator.ranges.posMax1 },
      ];
      this.gauges = new ChartGauge(config, this.alias);
      this.gauges.setHasErrorOnValueFormula(indicator.errorOnValueFormula);
      this.gauges.render();
      this.gauges.redraw(indicator.value);
    },
  },
  computed: {
    ...mapFields(["username"]),
    ...mapGetters(["getIndicatorData", "getCurrentSnapshot", "isPNUDADMIN", "isIndicaUser"]),
  },
  mounted() {
    // This let update the graphic when the language change
    this.unsubscribe = this.$store.subscribe((mutation) => {
      switch (mutation.type) {
        case "SET_LANG":
          var svg1 = this.$d3.select("#" + this.alias);
          svg1.selectAll(".gauge").remove();
          this.updateGauge();
          break;
      }
    });
    setTimeout(() => this.updateGauge(), 200);
  },
  beforeDestroy() {
    console.log("Destroy Gauge!!!");
    this.unsubscribe();
  },
};
</script>
<style lang="scss">
.IndicatorAddComment {
  color: #949293;
  position: absolute;
  bottom: 15px;
  right: 15px;
  font-weight: bold;
  cursor: pointer;
  .IndicatorAddCommentPlus {
    font-size: 30px;
    font-weight: 100;
    background-color: #949293;
    color: #ffffff;
    padding: 2px;
    line-height: 29px;
    display: inline-block;
    margin-left: 10px;
  }
}
</style>
